package one.healthium.events.di

import one.healthium.domain.user.UserEvents
import one.healthium.events.UserEventsChannel
import one.healthium.events.UserEventsImpl
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val eventsModule = module {
    singleOf(::UserEventsChannel)
    singleOf(::UserEventsImpl) bind UserEvents::class
}